import { Counter } from "./components/Counter";
import { Light } from "./components/UseHooks";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Light />
      <Counter />
    </div>
  );
}

export default App;
